export default function isProd() {
  return window.configs.API_HOST === 'https://api.luxuryescapes.com';
}
